var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99998 8.16666C2.99998 4.16666 6.33331 3.16666 7.99998 3.16666C12 3.16666 13 6.49999 13 8.16666V11.5L14.6666 13.1667H1.33331L2.99998 11.5V8.16666Z",
    fill: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 3.16667V1.5M5.49998 14C5.49998 14.8333 5.99998 16.5 7.99998 16.5C9.99998 16.5 10.5 14.8333 10.5 14M7.99998 3.16667C6.33331 3.16667 2.99998 4.16667 2.99998 8.16667V11.5L1.33331 13.1667H14.6666L13 11.5V8.16667C13 6.5 12 3.16667 7.99998 3.16667Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.33148f8a7cbfdf2acbf687b1eed34fd4.svg";
export { ForwardRef as ReactComponent };